"use client";

export interface StoreClosed {
    isStoreClose: boolean
    openCloseTime?: {
        open: string,
        close: string
    }
}

import { featureFlags } from '@lib/constants/network-constants';
import { routes } from '@lib/constants/routes-constant';
import { getFeatureFlagState } from '@lib/data';
import moment from 'moment';
import { usePathname, useRouter } from 'next/navigation';
import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
const StoreClosedContext = createContext<StoreClosed | undefined>(undefined);

export const ConfigStoreClosedProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const router = useRouter();
    const pathname = usePathname();
    const [isStoreClose, setIsStoreClose] = useState(false);
    const [openCloseTime, setOpenCloseTime] = useState<{ open: string; close: string }>();

    const getStoreClose = async () => {
        try {
            if (pathname === routes.redemption) {
                return;
            }

            const hasClosed = await getFeatureFlagState(featureFlags.GCM_STORE_CLOSED);
            const openTime = await getFeatureFlagState(featureFlags.GCM_OPEN_TIME, 20000, true);
            const closeTime = await getFeatureFlagState(featureFlags.GCM_CLOSING_TIME, 20000, true);
            if (!hasClosed || !openTime?.value || !closeTime?.value) {
                checkGoHome();
                return;
            }
            const dateOpenTime = moment().format('YYYY-MM-DD ') + openTime?.value;
            const dateCloseTime = moment().format('YYYY-MM-DD ') + closeTime?.value;

            setOpenCloseTime({
                open: openTime?.value,
                close: closeTime?.value
            });

            if ((moment().isBefore(dateOpenTime) || moment().isAfter(dateCloseTime))) {
                setIsStoreClose(true);
                router.push(routes.store_closed);
            } else {
                checkGoHome();
            }

        } catch (error) {
            console.error(`Failed to get : ${featureFlags.GCM_STORE_CLOSED}. Error: ${error}`);
        }
    }

    const checkGoHome = () => {
        if (
            pathname === routes.store_closed
        ) {
            router.push(routes.home);
        }
    }

    useEffect(() => {
        getStoreClose();
    }, [])

    const value = useMemo(() => {
        return {
            isStoreClose,
            openCloseTime
        }
    }, [isStoreClose])

    return <StoreClosedContext.Provider value={value}>
        {children}
    </StoreClosedContext.Provider>;
};

export const useStoreClosed = (): StoreClosed => {
    const context = useContext(StoreClosedContext);
    if (!context) {
        throw new Error('useStoreClosed must be used within a ConfigProvider');
    }
    return context;
};